//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Vue from "vue";
import avaliable_conf from '../../assets/configs/pay/available.json'
import rightpanel from "./rightpanel";


export default {
  name: "buy_gold",
  components: {
    rightpanel
  },
  data() {
    return {
      vip_configs: undefined,
      pay_way: avaliable_conf.defalut,
      select_id: '200rmbgold',
      pay_url: '',
      pay_loading: false,
      avaliable_conf: avaliable_conf,
      avaliable_payways: []
    };
  },
  methods: {
    get_pay_item: function (id) {
      for (var i = 0; i < this.vip_configs.length; ++i) {
        var vip_config = this.vip_configs[i];
        if (vip_config['id'] == id) {
          return vip_config;
        }
      }
    },
    update_payways: function () {
      this.avaliable_payways = [];
      var this_pay_item = this.get_pay_item(this.select_id);
      if (this_pay_item) {
        this.avaliable_conf.list.forEach((this_pay_way) => {
          if (this_pay_way.avaliable == false) {
            return;
          }
          var pay_amounts = this_pay_way['pay_amounts'];
          if (pay_amounts) {
            if (pay_amounts.indexOf(this_pay_item['amount']) >= 0) {
              this.avaliable_payways.push(this_pay_way);
            }
          } else {
            this.avaliable_payways.push(this_pay_way);
          }
        });
      }

      if (this.avaliable_payways.length == 0) {

      }
    },
    on_id_change: function () {
      Vue.nextTick(this.update_payways());
    },
    select_item: function (item_id) {
      this.select_id = item_id;
      this.update_payways();
    },
    click_pay: function () {
      this.pay_url = false;
      var post_data = {
        'pay-way': this.pay_way,
        'vip-id': this.select_id,
        'buygold': true
      };
      this.pay_loading = true;
      this.$axios.post('/app/pay/payment', post_data).then((response) => {
        this.pay_loading = false;
        var response_data = response.data;
        this.$message('请求支付成功，请稍等 ，正在跳转');
        var go_url = response_data.pay_data.read_url;
        setTimeout(() => {
          this.navigateToUrl(go_url);
        }, 200);
        this.pay_url = go_url;
      }).catch(function (error) {
        console.log('error:', error);
        var description = "请求支付失败，请重新尝试或者更换支付方式";
        this.$message(description);
        this.pay_loading = false;
      });
    }
  },
  created: function () {
    window._t = this;
    this.vip_configs = this.$buy_gold_conf['configs'];
    if (!this.select_id) {
      this.select_id = this.vip_configs[0].id;
      console.log('select this.select_id:', this.select_id);
    }
    this.select_item(this.select_id);
  }
}
